import { useTranslation } from "react-i18next";

import { Badge } from "./ui/badge";
import { currentServerToken, serverTokenOperatorEntry } from "../environments/primary/serverToken";

/**
 * Tells an operator in an entry session whose workspace they view. It floats
 * over the top edge and lets clicks through, because every route sizes itself
 * to the full viewport height.
 */
export function OperatorEntryBanner() {
  const { t } = useTranslation();
  const token = currentServerToken();
  const entry = token === null ? null : serverTokenOperatorEntry(token);
  if (entry === null) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-50 flex justify-center">
      <div role="status" className="rounded-b-md bg-background shadow-sm">
        <Badge variant="warning" className="rounded-t-none rounded-b-md px-3">
          {t("common/youAreViewingThe_labhh0", { name: entry.memberName })}
        </Badge>
      </div>
    </div>
  );
}
